<form [formGroup]="contractForm">
  <div tiimeFormTitle>Données du contrat</div>
  <div class="contract-form">
    <tiime-input-container
      [errorMessage]="contractForm.startDateErrorMessage?.message"
      contentId="start-date"
      label="Date de début"
    >
      <input
        #startDateInput
        id="start-date"
        placeholder="Date de début"
        formControlName="startDate"
        [matDatepicker]="startDatePicker"
        autocomplete="off"
      />
      <mat-icon
        color="primary"
        class="pointer"
        fontSet="fontastic"
        fontIcon="icon-calendar"
        tiimeSuffix
        (click)="startDatePicker.open()"
      ></mat-icon>
      <mat-datepicker
        panelClass="tiime-material-datepicker"
        [calendarHeaderComponent]="tiimeDatepickerHeader"
        #startDatePicker
      ></mat-datepicker>
    </tiime-input-container>
    <app-contributor-select
      label="Référent commercial"
      searchPlaceholder="Rechercher un référent commercial"
      [control]="contractForm.owner"
      [errorMessage]="contractForm.ownerErrorMessage"
      [partner]="partner"
    ></app-contributor-select>
    <app-business-unit-select
      [required]="true"
      [allowEmptyOption]="false"
      [selectData]="businessUnits"
      [control]="contractForm.businessUnit"
      [errorMessage]="contractForm.businessUnitErrorMessage"
      (selectionChange)="businessUnitChange($event)"
    ></app-business-unit-select>
    <app-contract-brand-select
      [control]="contractForm.brand"
      [selectData]="contractCommercialBrands$ | async"
      [businessUnitBrand]="contractBusinessUnitBrand()"
      [logoUrl]="logoUrl()"
      [logoLoading]="logoLoading()"
      (brandChange)="brandChange($event)"
    ></app-contract-brand-select>
  </div>
  <div tiimeFormVerticalSeparator></div>
  <div tiimeFormTitle>Prestations</div>
  @if (contractForm.prestations.controls?.length) {
    <app-prestations-form-table
      [prestationForms]="contractForm.prestations.controls"
      [tasks]="tasks"
      withHeader
      (removePrestation)="removePrestation($event)"
      (removeModelOffer)="removeModelOffer($event)"
    ></app-prestations-form-table>
  }
  @if (contractForm.prestationsErrorMessage?.message; as prestationsErrorMessage) {
    <div class="error-message">
      {{ prestationsErrorMessage }}
    </div>
  }
  <div class="add-prestation-container">
    @if (modelOffers?.length) {
      <tiime-input-container
        class="search-offer-input"
        small
        contentId="search-offer"
        label="Rechercher un modèle d'offre"
      >
        <input
          type="text"
          id="search-offer"
          placeholder="Rechercher un modèle d'offre"
          [formControl]="searchModelOfferControl"
          [matAutocomplete]="offerAutocomplete.autocomplete"
          (focus)="onSearchModelOffer(searchModelOfferControl.value)"
        />
        <app-offer-autocomplete
          #offerAutocomplete="OfferAutocomplete"
          [data]="filteredModelOffers()"
          (selectRecord)="onSelectModelOffer($event)"
        ></app-offer-autocomplete>
      </tiime-input-container>
      <span>OU</span>
    }
    <button
      [disabled]="contractForm.prestations.disabled"
      type="button"
      tiime-button
      color="primary"
      (click)="addNewPrestation()"
    >
      <mat-icon fontSet="fontastic" fontIcon="icon-ic-add-1"></mat-icon>
      Ajouter une prestation
    </button>
  </div>
  @if (annexModels?.length || contractForm.annexes.controls.length) {
    <div tiimeFormVerticalSeparator></div>
    <div tiimeFormTitle class="flex align-center gap-5">
      Annexes
      <mat-icon
        class="icon-info"
        fontSet="fontastic"
        fontIcon="icon-ic-info"
        tiimeTooltip="Les annexes, pilotées par un administrateur, permettent d'ajouter des éléments comme les débours (ex. : frais de greffe, journal d'annonce légale) au contrat. Elles peuvent être associées à une offre ou ajoutées librement pour clarifier la prise en charge de ces frais par le client ou le cabinet. À noter que le détail des annexes ne s'imprime pas sur l'interface de signature ni sur le contrat."
      ></mat-icon>
    </div>
  }
  <div class="annexes-container">
    @for (annexform of contractForm.annexes.controls; track i; let i = $index) {
      <div class="annex-container">
        <div class="annex-header">
          <span>Annexe : {{ annexform.label.value }}</span>
          <div class="flex align-center gap-5">
            @if (annexform.contractOffer.value; as contractOffer) {
              <tiime-tag [tag]="contractOffer.label" color="accent" />
            }
            <button
              tiime-button
              icon
              color="primary"
              [disabled]="annexform.disabled"
              tiimeTooltip="Retirer l'annexe"
              (click)="removeAnnex(i)"
            >
              <mat-icon fontSet="fontastic" fontIcon="icon-ic-remove"></mat-icon>
            </button>
          </div>
        </div>
        <app-contract-annex-line-form-table
          [contractAnnexLineForms]="annexform.lines.controls"
          [contractAnnexLineTypes]="contractAnnexLineTypes"
          [contractAnnexLineCharges]="contractAnnexLineCharges"
        ></app-contract-annex-line-form-table>
      </div>
    }
  </div>
  @if (annexModels?.length) {
    <tiime-input-container class="search-annex-input" small contentId="search-annex" label="Rechercher une annexe">
      <input
        type="text"
        id="search-annex"
        placeholder="Rechercher une annexe"
        [formControl]="searchAnnexModelControl"
        [matAutocomplete]="annexModelAutocomplete.autocomplete"
        (focus)="onSearchAnnexModel(searchAnnexModelControl.value)"
      />
      <app-annex-model-autocomplete
        #annexModelAutocomplete="AnnexModelAutocomplete"
        [data]="filteredAnnexModels()"
        (selectRecord)="onSelectAnnexModel($event)"
      ></app-annex-model-autocomplete>
    </tiime-input-container>
  }
  <div tiimeFormVerticalSeparator></div>
  <div tiimeFormTitle>Pièces jointes</div>
  @if (contractForm.files.controls?.length) {
    <app-contract-files-form-table
      [filesForms]="contractForm.files.controls"
      [fileTypes]="contractFileTypes$ | async"
      [contractStatus]="contractForm.contractStatus.value"
      (removeFile)="removeFile($event)"
      (downloadFile)="emitDownloadFile($event)"
      (openFileInNewTab)="emitOpenFileInNewTab($event)"
    ></app-contract-files-form-table>
  }
  <div class="add-file-container">
    <button
      type="button"
      tiime-button
      color="primary"
      [disabled]="contractForm.files.disabled"
      (click)="importFile(fileSelector)"
    >
      <mat-icon fontSet="fontastic" fontIcon="icon-ic-add-1"></mat-icon>
      Ajouter une pièce jointe
      <input
        hidden
        id="fileSelector"
        type="file"
        multiple
        [accept]="acceptedTypes"
        (change)="onFileSelected(fileSelector.files)"
        (cancel)="$event.stopPropagation()"
        (close)="$event.stopPropagation()"
        #fileSelector
      />
    </button>
  </div>
  <div tiimeFormVerticalSeparator></div>
  <div tiimeFormTitle>Note interne</div>
  <tiime-input-container class="internal-comment" tiimeFormInputContainer contentId="internal-comment">
    <textarea
      id="internal-comment"
      type="text"
      formControlName="internalComment"
      cdkTextareaAutosize
      cdkAutosizeMinRows="2"
    ></textarea>
  </tiime-input-container>
</form>
